(() => {
  if (customElements.get("cart-drawer-recommendation")) return;

  class CartDrawerRecommendation extends HTMLElement {
    constructor() {
      super();

      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
    }

    onClick(event) {
      const swatch = event.target.closest("[data-recommendation-swatch]");
      if (!swatch || !this.contains(swatch) || swatch.classList.contains("is-active")) return;

      const optionId = swatch.dataset.recommendationSwatch;

      this.querySelectorAll("[data-recommendation-swatch]").forEach((element) => {
        const isActive = element === swatch;

        element.classList.toggle("is-active", isActive);
        element.setAttribute("aria-pressed", String(isActive));
      });

      this.querySelectorAll("[data-recommendation-panel]").forEach((element) => {
        element.classList.toggle("is-active", element.dataset.recommendationPanel === optionId);
      });

      this.querySelector("[data-recommendation-add]")?.setAttribute("data-id", swatch.dataset.variantId);
    }
  }

  customElements.define("cart-drawer-recommendation", CartDrawerRecommendation);
})();
